module.exports = __webpack_public_path__ + "static/media/website-10.472437a1.png";